export default function IcpFooter() {
  return (
    <div className="fixed bottom-0 left-1/2 -translate-x-1/2 z-40 pointer-events-none select-none text-xs text-gray-400 pb-1">
      京ICP备2026034436号-1
    </div>
  );
}
